import React, { useEffect, useMemo, useState } from "react";
import {
  useAdminManageWeekly,
  useMyTeam,
  useWeeklyScheduleStore,
} from "./store";
import { Form } from "react-bootstrap";
import TempEngagement from "./TempEngagement";
import moment from "moment";
import CardDiv from "modules/common/card-div/CardDiv";
import {
  ROLES_NAME,
  getCurrentUserRole,
  getFormattedDate,
  orderOptions,
} from "modules/utilities/utility";
import SearchOption from "./SearchOption";
import FilterDownload from "./FilterDownload";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Badge, Button, Popover, Select, Tabs, Tooltip } from "antd";
import { Space } from "antd";
import { isEmpty } from "lodash";
import MedrepEngagementTable from "./MedrepEngagementTable";
import {
  getFormattedEndDate,
  revenueRepEndDate,
  revenueRepStartDate,
} from "functionCall";
import { ArrowLeftOutlined } from "@ant-design/icons";
import FilterIcon from "assets/svgs/filter_icon";

function MedRepEngagements() {
  const {
    repEngData,
    tempEngData,
    repReminderData,
    engLoading,
    tempEngLoading,
    fetchEngData,
    fetchTempData,
    fetchRepReminder,
    updateEngData,
  } = useWeeklyScheduleStore();
  const { fetchMyTeamData, teamData, tempLoading } = useMyTeam();
  const {
    medRepData,
    supportData,
    medRepExtData,
    leadData,
    fetchMedicalRepData,
    fetchMedicalExtData,
    fetchSupportData,
    fetchLeadData,
  } = useAdminManageWeekly();

  const [searchData, setSearchData] = useState(repEngData);
  const [value, setValue] = useState(null);
  const [medPerson, setMedPerson] = useState([]);
  const [medExtPerson, setMedExtPerson] = useState([]);
  const [leadPerson, setLeadPerson] = useState([]);
  const [person, setPerson] = useState([]);
  const [rescheduleCheck, setRescheduleCheck] = useState(false);
  const [countAssign, setCountAssign] = useState(0);
  const [assignId, setAssigneeId] = useState("");
  const [medRepName, setMedRepName] = useState("");
  const [refreshChecked, setRefreshChecked] = useState(false);
  const [orderFilter, setOrderFilter] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  const start = searchParams.get("sd");
  const end = searchParams.get("ed");
  const [selectedGender, setSelectedGender] = useState(null);
  const [selectAttempt, setSelectAttempt] = useState(null);
  const tabArray = ["Engagements", "Temporary Engagements"];
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [visible, setVisible] = useState(false);
  const tabObj = {
    Engagements: (
      <MedrepEngagementTable
        filterData={searchData}
        engLoading={engLoading}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
      />
    ),
    "Temporary Engagements": (
      <TempEngagement tempData={tempEngData} tempLoading={tempEngLoading} />
    ),
  };

  useEffect(() => {
    if (repEngData && repEngData.length > 0) {
      const sortedData = [...repEngData].sort(
        (a, b) => moment(b?.reminder_date) - moment(a.reminder_date)
      );
      setSearchData(sortedData);
    } else {
      setSearchData([]);
    }
  }, [repEngData]);

  const { setToaster } = useToast();

  useEffect(() => {
    if (refreshChecked) {
      setSelectedRowKeys([]);
      setRefreshChecked(false);
    }
  }, [refreshChecked]);

  useEffect(() => {
    fetchEngData(
      `${id}&start_date=${encodeURIComponent(
        start
      )}&end_date=${encodeURIComponent(end)}`
    );
    fetchTempData(
      `${id}&start_date=${encodeURIComponent(
        start
      )}&end_date=${encodeURIComponent(end)}`
    );
    fetchRepReminder(id, encodeURIComponent(start), encodeURIComponent(end));
    if (["admin", "super_admin", ROLES_NAME.TEAM_LEAD].includes(getCurrentUserRole())) {
      fetchMedicalRepData("medical_rep");
      fetchMedicalExtData("medrep_ext");
      fetchSupportData("support");
      fetchLeadData("lead_agent");
    } else {
      fetchMyTeamData();
    }
  }, [id, start, end]);

  useEffect(() => {
    if (["admin", "super_admin", ROLES_NAME.TEAM_LEAD].includes(getCurrentUserRole())) {
      const medRep = [...(medRepData?.userRole || [])]?.filter((item) => {
        if (item?.user_id !== id) {
          return true;
        } else {
          setMedRepName(item?.user?.first_name);
        }
      });
      const medExt = [...(medRepExtData?.userRole || [])]?.filter((item) => {
        if (item?.user_id !== id) {
          return true;
        }
      });

      const leadExt = [...(leadData?.userRole || [])]?.filter((item) => {
        if (item?.user_id !== id) {
          return true;
        }
      });
      setMedPerson(medRep);
      setMedExtPerson(medExt);
      setLeadPerson(leadExt);
    } else {
      const team = teamData?.userGroup?.filter((item) => {
        if (item?.user_id !== id) {
          return true;
        } else {
          setMedRepName(item?.user?.first_name);
        }
      });
      setPerson(team);
    }
  }, [teamData, medRepData, supportData, medRepExtData]);
  useEffect(() => {
    const filteredData = repEngData.filter((item) => {
      const orderCondition = orderFilter
        ? Number(orderFilter) > 3
          ? Number(item?.order?.count) >= Number(orderFilter)
          : Number(item?.order?.count) === Number(orderFilter)
        : true;

      const tagCondition = value
        ? (rescheduleCheck &&
            item.tag === value &&
            item?.reschedule_count > "0") ||
          (value === "SLOT_BOOKING_TOTAL" &&
            (item?.tag === "SLOT_BOOKING" || item?.is_slot_booked === true)) ||
          item.tag === value
        : true;

      if(value==="Lead"){
        if(item.request_type === "lead_cold_slot"){
          return true;
        }
      }

      if (selectAttempt) {
        const selectAttemptNumber = Number(selectAttempt);

        if (
          (selectAttemptNumber === 0 && item?.unanswered_count === 0) ||
          (selectAttemptNumber === 1 && item?.unanswered_count > 0)
        ) {
          return true;
        }
        return false;
      }

      const genderCondition = selectedGender
        ? item.case.user.gender === selectedGender
        : true;

      return orderCondition && tagCondition && genderCondition;
    });

    const sortedData = filteredData.sort(
      (a, b) => moment(b?.reminder_date) - moment(a.reminder_date)
    );

    setSearchData(sortedData);
  }, [orderFilter, value, selectedGender, rescheduleCheck, selectAttempt]);

  useEffect(() => {
    if (countAssign == 0) {
      return;
    } else {
      const data = selectedRowKeys?.map((item) => {
        return {
          engagementId: item,
          repId: assignId,
        };
      });
      if (data?.length) {
        updateEngData(
          data,
          setToaster,
          fetchEngData,
          fetchTempData,
          start,
          end,
          id,
          setAssigneeId,
          refreshChecked,
          setRefreshChecked
        );
      }
    }
  }, [countAssign]);

  const handleRescheduleChange = (event) => {
    if (event.target.checked) {
      setRescheduleCheck(true);
    } else {
      setRescheduleCheck(false);
    }
  };

  const data = useMemo(() => {
    if (!repEngData && !tempEngData) return [];
    const EngagementData = repEngData?.map((item) => ({
      Name: item?.order?.case?.user?.first_name || "-",
      Email: item?.order?.case?.user?.email || "-",
      "Engagement Tag": item?.tag || "-",
      "Phone Number": item?.order?.case?.user?.phone_number.toString() || "-",
      "Date of Engagement":
        moment(item?.reminder_date).format("DD-MM-YYYY HH:MM") || "-",
      "Order Id": item?.order?.order_display_id || "-",
      "Hair Coach": item?.user?.first_name || "-",
    }));

    const ReminderData = repReminderData?.map((item) => ({
      Name: item?.case?.user?.first_name || "-",
      Email: item?.case?.user?.email || "-",
      "Engagement Tag": item?.tag || "-",
      "Phone Number": String(item?.case?.user?.phone_number) || "-",
      "Date of Engagement":
        moment(item?.reminder_date).format("DD-MM-YYYY HH:MM") || "-",
      "Order Id": item?.case?.orders?.[0]?.order_display_id || "-",
      "Hair Coach": item?.user?.first_name || "-",
    }));

    return [...EngagementData, ...ReminderData];
  }, [repEngData, tempEngData]);

  const handleAssign = () => {
    setCountAssign(countAssign + 1);
  };

  const content = (
    <div
      className="d-flex flex-column popover-content"
      style={{ width: "15rem", height: "20rem" }}
    >
      <div className="d-flex flex-column gap-3">
        <Select
          allowClear
          options={orderOptions}
          placeholder="Filter Order"
          onChange={(selectedRowKeys) => {
            setOrderFilter(selectedRowKeys);
          }}
          style={{
            width: "14rem",
            height: "2.5rem",
            marginRight: "1rem",
          }}
        />
        <div className="">
          <Select
            allowClear
            placeholder="Filter by Gender"
            onChange={(selectedGender) => setSelectedGender(selectedGender)}
            style={{
              width: "14rem",
              height: "2.5rem",
              marginRight: "1rem",
            }}
          >
            <Option value="M">Male</Option>
            <Option value="F">Female</Option>
          </Select>
        </div>
        <div className="">
          <Select
            allowClear
            placeholder="Filter by Attempt"
            onChange={(selectAttempt) => setSelectAttempt(selectAttempt)}
            style={{
              width: "14rem",
              height: "2.5rem",
              marginRight: "1rem",
            }}
          >
            <Option value="0">zero</Option>
            <Option value="1">Greater than Zero</Option>
          </Select>
        </div>
        <div className="d-flex flex-column">
          <div className="">
            <SearchOption value={value} setValue={setValue} />
          </div>
          <Form.Check
            className=""
            type="checkbox"
            id="checkedCheckbox"
            label="Apply filter for Engagement"
            onChange={handleRescheduleChange}
          />
          <div className="mt-4 float-end text-end me-3">
            <Button
              className="w-50"
              danger
              onClick={() => setVisible(!visible)}
            >
              close
            </Button>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <CardDiv
        title={
          <>
            <div className="d-flex flex-row justify-content-between my-n2 align-items-center flex-wrap">
              <div className="d-flex flex-row align-items-center w-25 gap-2">
                <Button
                  icon={<ArrowLeftOutlined />}
                  onClick={() => {
                    navigate(
                      `/manage-weekly-schedules?sd=${revenueRepStartDate(
                        getFormattedEndDate(1)
                      )}&ed=${revenueRepEndDate(getFormattedEndDate(0))}`
                    );
                  }}
                  size={"small"}
                />
                <div className="text-black text-capitalize">
                  {medRepName ? (
                    medRepName
                  ) : (
                    <span className="text-white">-</span>
                  )}
                </div>
              </div>

              <div className="d-flex align-self-end align-items-center">
                <div className="d-flex flex-row gap-2 text-primary align-items-center">
                  <div className="border rounded p-1 px-2 mt-1 shadow-sm text-secondary">
                    Selected Row :
                    <span className="text-primary ps-1">
                      {selectedRowKeys.length}
                    </span>
                  </div>
                  {["admin", "super_admin", ROLES_NAME.TEAM_LEAD].includes(getCurrentUserRole()) ? (
                    <Select
                      allowClear
                      onChange={(selectedRowKeys) =>
                        setAssigneeId(selectedRowKeys)
                      }
                      optionFilterProp="label"
                      placeholder="Select a person"
                      showSearch
                      style={{ width: 240, marginLeft: 10, marginTop: 5 }}
                      value={assignId}
                    >
                      {!isEmpty(medPerson) &&
                        medPerson?.map((rep) => (
                          <Option
                            label={rep.user.first_name}
                            value={rep.user.id}
                            key={rep.user.id}
                          >
                            <Space align="center">
                              <div>{rep.user.first_name}</div>
                              <Badge
                                count="Medical Rep"
                                style={{
                                  backgroundColor: "#f1f1f1",
                                  color: "#313131",
                                }}
                              />
                            </Space>
                          </Option>
                        ))}

                      {!isEmpty(medExtPerson) &&
                        medExtPerson?.map((rep) => (
                          <Option
                            label={rep.user.first_name}
                            value={rep.user.id}
                            key={rep.user.id}
                          >
                            <Space align="center">
                              <div>{rep.user.first_name}</div>
                              <Badge
                                count="Medical Rep External"
                                style={{
                                  backgroundColor: "#f1f1f1",
                                  color: "#313131",
                                }}
                              />
                            </Space>
                          </Option>
                        ))}

                      {!isEmpty(leadPerson) &&
                        leadPerson?.map((rep) => (
                          <Option
                            label={rep?.user?.first_name}
                            value={rep?.user?.id}
                            key={rep?.user?.id}
                          >
                            <Space align="center">
                              <div>{rep?.user?.first_name}</div>
                              <Badge
                                count="Lead-Agent"
                                style={{
                                  backgroundColor: "#f1f1f1",
                                  color: "#313131",
                                }}
                              />
                            </Space>
                          </Option>
                        ))}
                    </Select>
                  ) : (
                    <Select
                      allowClear
                      onChange={(selectedRowKeys) =>
                        setAssigneeId(selectedRowKeys)
                      }
                      optionFilterProp="label"
                      placeholder="Select a person"
                      showSearch
                      style={{ width: 240, marginLeft: 10 }}
                      value={assignId}
                    >
                      {!isEmpty(person) &&
                        person?.map((rep) => (
                          <Option
                            label={rep.user.first_name}
                            value={rep.user.id}
                            key={rep.user.id}
                          >
                            <Space align="center">
                              <div>{rep.user.first_name}</div>
                              <Badge
                                count="Medical Rep"
                                style={{
                                  backgroundColor: "#f1f1f1",
                                  color: "#313131",
                                }}
                              />
                            </Space>
                          </Option>
                        ))}
                    </Select>
                  )}
                  <Button
                    variant="primary"
                    type="primary"
                    className={assignId ? "me-0" : "disabled me-0"}
                    onClick={handleAssign}
                    style={{
                      height: "2.4rem",
                      marginTop: "5px",
                      marginLeft: "-18px",
                    }}
                  >
                    Assign
                  </Button>
                  <FilterDownload data={data} medRepName={medRepName} />
                  <Popover
                    content={content}
                    title="Filter For Engagement"
                    trigger="click"
                    placement="leftTop"
                    visible={visible}
                    overlayClassName="popover-border"
                  >
                    <Tooltip placement="top" title="Filter">
                      <Button
                        type="primary"
                        className=" border fs-2 text-white mb-n2 cursor-pointer"
                        onClick={() => setVisible(!visible)}
                        style={{ height: "2.4rem" }}
                      >
                        <FilterIcon />
                      </Button>
                    </Tooltip>
                  </Popover>
                </div>
              </div>
            </div>
          </>
        }
        component={
          <div className="scrollable-container mt-n3">
            <Tabs
              type="card"
              items={tabArray?.map((item, index) => {
                const id = String(index + 1);
                return {
                  label: item,
                  key: id,
                  children: tabObj[item],
                };
              })}
            />
          </div>
        }
      />
    </div>
  );
}

export default MedRepEngagements;
